<div class="container">
    <span
        hamIconShapes
        class="icon"
        icon="assets/hamIcons/upload-document.svg"
        [variant]="'indigo'"
        [size]="'lg'"
        [type]="'square'"
    ></span>
    <p class="title">{{ 'aumico_reports_project_upload_document_title' | i18next }}</p>
    <p class="description">
        {{ 'aumico_reports_project_upload_document_description' | i18next }}<b>{{ acceptedExtensions }}</b>
    </p>
    <div class="file-upload" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
        <input
            #fileInput
            type="file"
            [multiple]="multiUpload"
            (change)="onFileUploadedChanged($event.target.files); resetFiles($event)"
            hidden
            [accept]="acceptedExtensions"
        />
        <span class="ham-icon"> <i class="upload-icon"></i></span>

        <p class="text">{{ 'aumico_reports_project_upload_document_drag' | i18next }}</p>

        <a class="link" (click)="fileInput.click()">{{ 'aumico_reports_browse_files' | i18next }}</a>

        <p class="details">{{ 'aumico_reports_project_upload_document_details' | i18next }}</p>

        <span class="extension-error" *ngIf="fileExtensionError"
            >{{ 'aumico_reports_companies_upload_file_upload_error_format' | i18next }}
        </span>
    </div>
</div>

<div class="file-info" *ngFor="let fileMetaData of filesMetaData">
    <span class="img-icon ham-icon" icon="assets/hamIcons/image-outline.svg">
        <i class="image-outline-icon"></i>
    </span>
    <div>
        <div class="name">{{ fileMetaData.name }}</div>
    </div>
    <span class="ham-icon check-circle-green" icon="assets/hamIcons/check-circle.svg">
        <i class="check-circle"></i>
    </span>
</div>
